export const albumsMocked = [
  {
    id: 1,
    albumDescription: 'mountains',
    albumName: 'find your way',
    coverDescription: 'mountains',
    coverUrl:
      'https://i.pinimg.com/564x/b7/e1/e0/b7e1e0ccf375e3b303c1daeefc59fa08.jpg',
  },
  {
    id: 2,
    albumDescription: 'sea',
    albumName: 'sea and people',
    coverDescription: 'sea',
    coverUrl:
      'https://brbymary.com/wp-content/uploads/2021/11/Couple-at-the-free-Horsheshoe-Bay-Lookout-Platform-5-768x1152.jpg',
  },
  {
    id: 3,
    albumDescription: 'white&grey',
    albumName: 'weddings',
    coverDescription: 'weddings',
    coverUrl:
      'https://i.insider.com/62cdb9828045920019aeaf45?width=1000&format=jpeg&auto=webp',
  },
  {
    id: 4,
    albumDescription: 'nature and water',
    albumName: 'nature and water',
    coverDescription: 'nature and water',
    coverUrl:
      'https://live.staticflickr.com/65535/51256068003_017334c7b8_o.jpg',
  },
  {
    id: 5,
    albumDescription: 'mother and daughter',
    albumName: 'mother and daughter',
    coverDescription: 'mother and daughter',
    coverUrl:
      'https://osvitanova.com.ua/ckeditor_assets/pictures/14185/content_pexels-photo-3760279.jpeg',
  },
  {
    id: 6,
    albumDescription: 'deer',
    albumName: 'deer',
    coverDescription: 'deer',
    coverUrl:
      'https://iso.500px.com/wp-content/uploads/2016/03/stock-photo-142984111.jpg',
  },
  {
    id: 7,
    albumDescription: 'man in grey',
    albumName: 'man in grey',
    coverDescription: 'man in grey',
    coverUrl:
      'https://images.pexels.com/photos/842569/pexels-photo-842569.jpeg',
  },
  {
    id: 8,
    albumDescription: 'underwater',
    albumName: 'underwater',
    coverDescription: 'underwater',
    coverUrl:
      'https://images.pexels.com/photos/2765871/pexels-photo-2765871.jpeg?auto=compress&cs=tinysrgb&w=600',
  },
  {
    id: 9,
    albumDescription: 'man in grey',
    albumName: 'man in grey',
    coverDescription: 'man in grey',
    coverUrl:
      'https://images.pexels.com/photos/842569/pexels-photo-842569.jpeg',
  },
  {
    id: 10,
    albumDescription: 'underwater',
    albumName: 'underwater',
    coverDescription: 'underwater',
    coverUrl:
      'https://images.pexels.com/photos/2765871/pexels-photo-2765871.jpeg?auto=compress&cs=tinysrgb&w=600',
  },
];
